module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABESURBVHgB7dSxEQAQEETRvyqhFq2oSi9qoROEcheYcS+84KI/K2ruiIgFMQJM7Fj+cu/SVYe7O0pL5+myQ+/uT3p+DxcYtw+ASH/N+wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Group4.png
// module id = +Eo2
// module chunks = 1